import { wrapRequest } from "..";
import { ILogBase } from "../../Middleware/LoggingMiddleware";
import { LoggingLevel } from "../../Enums/shared";

export const activityLogStore = "logDataStore";

export default class ActivityLogDB {
  static activityLogDB: IDBDatabase;

  static initializeDB = (db: IDBDatabase) => {
    ActivityLogDB.activityLogDB = db;
  };

  static createStore = (db: IDBDatabase) => {
    //create drivers license store
    let activityLogObjectStore = db.createObjectStore(activityLogStore, {
      keyPath: "elasticIndex"
    });

    activityLogObjectStore.createIndex("esIndex", ["elasticIndex"]);
    activityLogObjectStore.createIndex("logCategoryIndex", ["logCategory"]);
    activityLogObjectStore.createIndex("logCreatedIndex", ["timestamp"]);
    activityLogObjectStore.createIndex("logLevelIndex", ["logLevel"]);
    activityLogObjectStore.transaction.oncomplete = (event: any) => {
      console.log("Activity Log collection created!");
    };
  };

  /**
   * @description save new item for logging
   * @param {ILogBase} logData - log data
   */
  static saveActivityToLog = (logData: ILogBase): Promise<any> => {
    return wrapRequest(
      ActivityLogDB.activityLogDB
        .transaction(activityLogStore, "readwrite")
        .objectStore(activityLogStore)
        .put(logData)
    );
  };

  /**
   * @description Get all Activity Logs
   * @returns promise
   */

  static getAllActivityLogs = (): Promise<ILogBase[]> => {
    return wrapRequest(
      (ActivityLogDB.activityLogDB
        .transaction(activityLogStore, "readonly")
        .objectStore(activityLogStore)
        .index("esIndex") as any).getAll()
    ).then((result: ILogBase[]) => result);
  };

  /**
   * @description clear all saved logs
   * @returns promise
   */
  static clearAllActivityLogData = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      try {
        ActivityLogDB.activityLogDB
          .transaction(activityLogStore, "readwrite")
          .objectStore(activityLogStore).clear();
        
            resolve();
      } catch (ex) {
        reject();
      }
    });
  };

  /**
   * @description Get all Activity Logs by log level
   * @returns promise
   */

  static getActivityLogsByLogLevel = (logLevel: Number[]): Promise<ILogBase[]> => {
    let filteredLogBase: ILogBase[] = [];
    return wrapRequest(
      (ActivityLogDB.activityLogDB
        .transaction(activityLogStore, "readonly")
        .objectStore(activityLogStore)
        .index("logLevelIndex") as any).getAll()
    ).then((result: ILogBase[]) => {
      if (result) {
        result.forEach((res: ILogBase) => {
          if (logLevel.includes(res.logLevel)) filteredLogBase.push(res);
        });
      }
      return filteredLogBase;
    });
  };
}
